import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const Svg2Personen = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <g clipPath="url(#2-Personen_svg__a)">
      <mask
        id="2-Personen_svg__b"
        width={12}
        height={28}
        x={7}
        y={6}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          d="M14.22 18a6 6 0 1 0-2.44 0A6 6 0 0 0 7 23.88v10h12v-10A6 6 0 0 0 14.22 18"
        />
      </mask>
      <g mask="url(#2-Personen_svg__b)">
        <path
          fill="#F7A941"
          d="M9.54 52.87-2.71 45.8l7.07-12.25z"
        />
        <path
          fill="#FED27A"
          d="m28.86 47.7-12.25-7.08 7.07-12.24z"
        />
        <path
          fill="#F7A941"
          d="m4.36 33.55 12.25 7.07-7.07 12.25z"
        />
        <path
          fill="#F7A941"
          d="m23.68 28.38-7.07 12.24-12.25-7.07z"
        />
        <path
          fill="#FED27A"
          d="M18.5 9.06 6.26 1.99l7.07-12.25z"
        />
        <path
          fill="#FED27A"
          d="M-.81 14.23 6.26 1.99 18.5 9.06z"
        />
        <path
          fill="#F7A941"
          d="m13.33-10.26 12.25 7.07L18.5 9.06z"
        />
        <path
          fill="#F7A941"
          d="m18.5 9.06 7.08-12.25 12.24 7.07z"
        />
        <path
          fill="#FED27A"
          d="m18.5 9.06 12.25 7.07-7.07 12.25z"
        />
        <path
          fill="#F7A941"
          d="m37.82 3.88-7.07 12.25L18.5 9.06z"
        />
        <path
          fill="#FED27A"
          d="m-.81 14.23 12.24 7.08-7.07 12.24zM23.68 28.38l-12.25-7.07L18.5 9.06z"
        />
        <path
          fill="#FED27A"
          d="m18.5 9.06-7.07 12.25-12.24-7.08z"
        />
        <path
          fill="#FED27A"
          d="m4.36 33.55 7.07-12.24 12.25 7.07z"
        />
      </g>
      <mask
        id="2-Personen_svg__c"
        width={12}
        height={28}
        x={21}
        y={6}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          d="M28.22 18a6 6 0 1 0-2.44 0A6 6 0 0 0 21 23.88v10h12v-10A6 6 0 0 0 28.22 18"
        />
      </mask>
      <g mask="url(#2-Personen_svg__c)">
        <path
          fill="#F18700"
          d="m34.14 25.49-12.25-7.07 7.08-12.25zM9.65 11.35l12.24 7.07-7.07 12.25z"
        />
        <path
          fill="#F7A941"
          d="m14.82 30.67 7.07-12.25 12.25 7.07zM28.97 6.17l-7.08 12.25-12.24-7.07z"
        />
        <path
          fill="#F18700"
          d="m28.97 6.17 12.24 7.07-7.07 12.25z"
        />
        <path
          fill="#F18700"
          d="m48.28.99-7.07 12.25-12.24-7.07z"
        />
        <path
          fill="#F7A941"
          d="M28.97 6.17 16.72-.9l7.07-12.25z"
        />
        <path
          fill="#F18700"
          d="M9.65 11.35 16.72-.9l12.25 7.07zM23.79-13.15l12.25 7.07-7.07 12.25z"
        />
        <path
          fill="#F7A941"
          d="m28.97 6.17 7.07-12.25L48.28.99z"
        />
        <path
          fill="#F18700"
          d="m14.82 30.67 12.25 7.07L20 49.98z"
        />
        <path
          fill="#F7A941"
          d="m39.32 44.81-12.25-7.07 7.07-12.25z"
        />
        <path
          fill="#F18700"
          d="m34.14 25.49-7.07 12.25-12.25-7.07z"
        />
      </g>
    </g>
    <defs>
      <clipPath id="2-Personen_svg__a">
        <path
          fill="#fff"
          d="M0 0h40v40H0z"
        />
      </clipPath>
    </defs>
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(Svg2Personen);

export default ForwardRef;
